module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 145
// module chunks = 62